import { Autocomplete, TextField } from '@mui/material';
import React, { useState } from 'react';
import { FiFilter } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';



export default function SearchFilterModal(
    { handleSubmit,
        isLoading,
        developer,
        setProjectStatus,
        setDeveloper,
        developerOptions,
        project,
        setProject,
        projectOptions,
        communityOptions,
        roomOptions,
        unitTypeOptions,
        salesStatusOptions,
        projectStatusOptions,
        projectTypeOptions,
        amenityOptions,

        projectStatus,
        setSalesStatus,
        salesStatus,
        setProjectType,
        projectType,
        setUnitType,
        unitType,
        setRooms,
        rooms,
        setFacility,
        facility,
        setCommunity,
        community,
        setRentalGuarantee,
        rentalGuarantee,
        setPaymentPlan,
        paymentPlan,
        setDeliveryPlan,
        deliveryPlan,
        setMinPrice,
        minPrice,
        setMaxPrice,
        maxPrice,
        setMinArea,
        minArea,
        setMaxArea,
        maxArea,
        setDownPayment,
        downPayment,
        setDeliveryDate,
        deliveryDate,
        handleRest,
        handleSearch,
        setPage,
        setPropertyData,
        amenity,
        setIsLoading,
        setSearchTrigger,

        setNewUnitType,
        newUnitType,
    }
) {
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslation();

    console.log(projectStatusOptions, 'projectStatusOptions')
    const yesOrNoOptions = [
        { label: 'Yes', value: 1 },
        { label: 'No', value: "0" },
    ]

    const deleiveryYears = [
        { label: '2025', value: 2025 },
        { label: '2026', value: 2026 },
        { label: '2027', value: 2027 },
        { label: '2028', value: 2028 },
        { label: '2029', value: 2029 },
        { label: '2030', value: 2030 },
    ]


    const formatNumber = (value) => {
        if (typeof value !== 'string') {
            value = String(value || ''); // Convert non-string values to string
        }
        const numericValue = value.replace(/,/g, '');  // Remove commas
        if (!numericValue) return '';  // Return empty if no valid input
        return Number(numericValue).toLocaleString('en-US');  // Format with commas
    };

    // Handle input change for any field
    const handleBudgetChange = (e, name) => {
        const input = e.target.value.replace(/,/g, ''); // Remove commas
        // Allow only digits
        if (/^\d*$/.test(input)) {
            if (name === 'minPrice') setMinPrice(input);
            if (name === 'maxPrice') setMaxPrice(input);
            if (name === 'minArea') setMinArea(input);
            if (name === 'maxArea') setMaxArea(input);
            if (name === 'downPayment') setDownPayment(input);
        }
    };

    return (
        <>
            {/* Trigger Button */}
            <button
                className="px-4 py-2 bg-teal-600 text-white rounded-md hover:bg-teal-700 transition"
                onClick={() => setIsOpen(true)}
            >
               {t('searchFilter.advance_filter')}
            </button>

            {/* Backdrop & Modal */}
            {isOpen && (
                <div className=" fixed inset-0 z-50 flex items-center justify-center bg-black/50 bg-opacity-50">
                    <div className=" bg-white rounded-xl shadow-lg max-w-sm w-full p-2 relative">
                        {/* Close Button */}
                        

                        {/* Modal Content */}
                        <h2 className="text-xl font-semibold mb-4">{t('searchFilter.advance_filter')}</h2>

                        <div className="p-4 overflow-y-auto h-[calc(80vh-64px)]">
                            <div className=' flex flex-col gap-y-6 mb-5'>
                                <Autocomplete
                                    size="small"
                                    options={projectOptions}
                                    value={project}
                                    onChange={(_, newValue) => setProject(newValue)}
                                    getOptionLabel={(option) => option?.label || ""}
                                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Project Name" />
                                    )}
                                />

                                <Autocomplete
                                    size="small"
                                    options={developerOptions}
                                    value={developer}
                                    onChange={(_, val) => setDeveloper(val)}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Preferred Developer" />
                                    )}
                                />

                                {/* <Autocomplete
                                    size="small"
                                    options={projectOptions}
                                    // value={project}
                                    // onChange={(_, newValue) => setProject(newValue)}
                                    getOptionLabel={(option) => option?.label || ""}
                                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Marketing Company" />
                                    )}
                                /> */}

                                {/* <Autocomplete
                                    size="small"
                                    options={projectOptions}
                                    // value={project}
                                    // onChange={(_, newValue) => setProject(newValue)}
                                    getOptionLabel={(option) => option?.label || ""}
                                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                                    renderInput={(params) => (
                                        <TextField {...params} label="City" />
                                    )}
                                /> */}

                                <Autocomplete
                                    size="small"
                                    options={communityOptions}
                                    value={community}
                                    onChange={(_, newValue) => setCommunity(newValue)}
                                    getOptionLabel={(option) => option?.label || ""}
                                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Neighborhood " />
                                    )}
                                />

                                <Autocomplete
                                    size="small"
                                    // 4) never undefined thanks to safe fallback
                                    options={projectStatusOptions || []}
                                    value={projectStatus}
                                    onChange={(_, newOption) => setProjectStatus(newOption)}
                                    getOptionLabel={(opt) => opt.label || ""}
                                    isOptionEqualToValue={(opt, val) => opt.value === val?.value}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Project Status" />
                                    )}
                                />

                                <Autocomplete
                                    size="small"
                                    options={salesStatusOptions || []}
                                    value={salesStatus}
                                    onChange={(_, newValue) => setSalesStatus(newValue)}
                                    getOptionLabel={(option) => option?.label || ""}
                                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Sales Status" />
                                    )}
                                />

                                <Autocomplete
                                    size="small"
                                    options={projectTypeOptions}
                                    value={projectType || ''}
                                    onChange={(_, newValue) => setProjectType(newValue)}
                                    getOptionLabel={(option) => option?.label || ""}
                                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Project Type" />
                                    )}
                                />

                                <Autocomplete
                                    size="small"
                                    options={unitTypeOptions}
                                    value={newUnitType || ''} 
                                    onChange={(_, newValue) => setNewUnitType(newValue)}
                                    getOptionLabel={(option) => option?.label || ""}
                                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Unit Type" />
                                    )}
                                />

                                <Autocomplete
                                    size="small"
                                    options={roomOptions}
                                    value={rooms}
                                    onChange={(_, newValue) => setRooms(newValue)}
                                    getOptionLabel={(option) => option?.label || ""}
                                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Rooms" />
                                    )}
                                />

                                <Autocomplete
                                    size="small"
                                    options={amenityOptions}
                                    value={amenity}
                                    onChange={(_, newValue) => setFacility(newValue)}
                                    getOptionLabel={(option) => option?.label || ""}
                                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Facilities" />
                                    )}
                                />

                                <Autocomplete
                                    size="small"
                                    options={yesOrNoOptions}
                                    value={rentalGuarantee}
                                    onChange={(_, newValue) => setRentalGuarantee(newValue)}
                                    getOptionLabel={(option) => option?.label || ""}
                                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Rental Guarantee" />
                                    )}
                                />

                                <Autocomplete
                                    size="small"
                                    options={yesOrNoOptions}
                                    value={paymentPlan}
                                    onChange={(_, newValue) => setPaymentPlan(newValue)}
                                    getOptionLabel={(option) => option?.label || ""}
                                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Payment Plan" />
                                    )}
                                />

                                <Autocomplete
                                    size="small"
                                    options={yesOrNoOptions}
                                    value={deliveryPlan}
                                    onChange={(_, newValue) => setDeliveryPlan(newValue)}
                                    getOptionLabel={(option) => option?.label || ""}
                                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Post Delivery Payment Plan" />
                                    )}
                                />

                                <TextField
                                    size="small"
                                    label="Min Price (AED)"
                                    multiline
                                    minRows={1}
                                    fullWidth
                                    value={formatNumber(minPrice)} 
                                    onChange={(e) => handleBudgetChange(e, 'minPrice')} 
                                    inputProps={{ inputMode: 'numeric' }}
                                />

                                <TextField
                                    size="small"
                                    label="Max Price (AED)"
                                    multiline
                                    minRows={1}
                                    fullWidth
                                    value={formatNumber(maxPrice)}
                                    onChange={(e) => handleBudgetChange(e, 'maxPrice')}
                                    inputProps={{ inputMode: 'numeric' }}
                                />

                                <TextField
                                    size="small"
                                    label="Min Area ft²"
                                    multiline
                                    minRows={1}
                                    fullWidth
                                    value={formatNumber(minArea)}
                                    onChange={(e) => handleBudgetChange(e, 'minArea')} 
                                    inputProps={{ inputMode: 'numeric' }}
                                 
                                />

                                <TextField
                                    size="small"
                                    label="Max Area ft²"
                                    multiline
                                    minRows={1}
                                    fullWidth
                                    value={formatNumber(maxArea)}
                                    onChange={(e) => handleBudgetChange(e, 'maxArea')} 
                                    inputProps={{ inputMode: 'numeric' }}
                                 
                                />

                                <Autocomplete
                                    size="small"
                                    options={deleiveryYears}
                                    value={deliveryDate}
                                    onChange={(_, newValue) => setDeliveryDate(newValue)}
                                    getOptionLabel={(option) => option?.label || ""}
                                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Delivery" />
                                    )}
                                />

                                <TextField
                                    size="small"
                                    label="Down Payment"
                                    multiline
                                    minRows={1}
                                    fullWidth
                                    value={formatNumber(downPayment)}
                                    onChange={(e) => handleBudgetChange(e, 'downPayment')} 
                                    inputProps={{ inputMode: 'numeric' }}
                                />

                            </div>
                        </div>

                        <div className="flex justify-end space-x-2 mt-3">
                            <button
                                className="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300 transition"
                                onClick={handleRest}
                            >
                                 {t('searchFilter.reset')}
                            </button>
                            <div className="flex justify-end">
                                <button
                                     onClick={() => {
                                            handleSubmit();  // Call handleSubmit
                                            setIsOpen(false); // Call setIsOpen(false)
                                        }}
                                    disabled={isLoading} // 🛑 Prevent repeated clicks
                                    className={`bg-teal-500 hover:bg-teal-600 text-white rounded-full px-6 py-3 flex items-center justify-center gap-2 ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
                                >
                                    <FiFilter className="text-lg" />
                                   {isLoading ? t('searchFilter.searching') : t('searchFilter.findProperties')}

                                </button>

                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}